import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetUserSkillQuery } from '@/generated/graphql'

import { UserInfoSkillInner } from '../user-info-skill/user-info-skill.component'
import { UserInfoProps } from '../user-info.interface'

export const UserInfoEditModalSkill: React.FC<UserInfoProps> = ({ userId, viewerId }) => {
  const { t } = useTranslation()

  const { data } = useGetUserSkillQuery({
    variables: {
      userId,
      skillPagination: {
        last: 100,
      },
      evaluatedUserPagination: {
        last: 1000,
      },
    },
  })

  const skills = data?.user.skills?.edges.map(({ node }) => node) || []

  return (
    <div>
      <Typography.Title level={5}>{t('user.info.skill.title')}</Typography.Title>
      <UserInfoSkillInner userId={userId} viewerId={viewerId} bodyStyle={{ padding: '0 15px' }} skills={skills} />
    </div>
  )
}
